import type {JSONObject} from './types'

/** Just calls `JSON.stringify`, but with better typesafety, ensuring that the object is serializable. */
export function serializeJsonObject(object: JSONObject) {
  return JSON.stringify(object)
}

/** Parse a string as JSON and assert that the result is an object. */
export function parseJsonObject(json: string): JSONObject {
  const result = JSON.parse(json)
  if (typeof result === 'object' && result !== null && !Array.isArray(result)) return result as JSONObject
  throw new TypeError(`Failed to parse JSON object: expected an object but got ${typeof result}`)
}
